import React, { useEffect, useRef } from 'react';
import type { MenuListProps } from 'react-select';
import { components } from 'react-select';

interface ScrollIntoViewMenuListProps<Option, IsMulti extends boolean = false> extends MenuListProps<Option, IsMulti> {
    alwaysScrollIntoView?: boolean;
}

export function ScrollIntoViewMenuList<Option, IsMulti extends boolean = false>({
    alwaysScrollIntoView = false,
    innerRef,
    ...props
}: ScrollIntoViewMenuListProps<Option, IsMulti>) {
    const localRef = useRef<HTMLDivElement | null>(null);

    const setRefs = (node: HTMLDivElement | null) => {
        localRef.current = node;

        if (typeof innerRef === 'function') {
            innerRef(node);
        } else if (innerRef && 'current' in innerRef) {
            (innerRef as React.MutableRefObject<HTMLDivElement | null>).current = node;
        }
    };

    useEffect(() => {
        if (!alwaysScrollIntoView || !localRef.current) return;

        const selected = localRef.current.querySelector('.selector__option--is-selected') as HTMLElement | null;

        if (selected)
            selected.scrollIntoView({
                block: 'nearest',
            });
    }, [props.selectProps.menuIsOpen, alwaysScrollIntoView]);

    return (
        <components.MenuList
            {...props}
            innerRef={setRefs}
        />
    );
}
